module.exports = __webpack_public_path__ + "img/auth-v1-dark.c2248932.svg";